import { render, staticRenderFns } from "./CheckoutMenu.vue?vue&type=template&id=5f21aba1"
import script from "./CheckoutMenu.vue?vue&type=script&lang=ts"
export * from "./CheckoutMenu.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutMenu.vue?vue&type=style&index=0&id=5f21aba1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports